const Accordion = {
	init() {
		const items = document.querySelectorAll('.accordion .accordion__toggle-item');
		if (items != null && items.length > 0) {
			items.forEach((item) => item.addEventListener('click', this.toggleAccordion));
		}
	},

	toggleAccordion() {
		this.classList.toggle('active');
	},
};

export { Accordion as default };
